module.exports = __webpack_public_path__ + "static/img/nolevel.31e86c56.png";